import {ApiService} from "./api.service";

export class WebsiteLayoutService extends ApiService {
  constructor(organizationId) {
    super();
    this.endpoint = `/organizations/${organizationId}/website/layouts`;
  }

  publishedLayout(params) {
    let url = `${this.endpoint}/published_layout`;
    return this.get(url, params).then(res => res)
      .catch((e) => {
        return {};
      });
  }

  publishedLayoutNoSlug() {
    let url = '/website/layouts/published_layout';
    return this.get(url)
      .then(res => res)
      .catch((e) => {
        return {};
      });
  }

  draftLayout(params) {
    let url = `${this.endpoint}/draft_layout`;
    return this.get(url, params).then(res => res)
      .catch((e) => {
        return {};
      });
  }

  publishCurrentDraft() {
    let url = `${this.endpoint}/publish_draft`;
    return this.get(url).then(res => res)
      .catch((e) => {
        console.warn("error publishing draft", e);
        return false;
      });
  }

}
